import { render, staticRenderFns } from "./MultiplyCutting.vue?vue&type=template&id=0875a5c9"
import script from "./MultiplyCutting.vue?vue&type=script&lang=js"
export * from "./MultiplyCutting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports